import { ca } from "date-fns/locale";
import { getInitialState, getPath } from "../../utils";

const initialState = {
  attributeMappingList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_ATTRIBUTE_LIST":
      return setAttributeList(state, action);
    case "SET_USER_ATTRIBUTE_LIST":
      return setUserAttributeList(state, action);
    case "SET_ACTION_TYPE_LIST":
      return setActionsList(state, action);
    case "SET_USER_ID":
      return setUserId(state, action);
    case "SET_ACTION_ATTRIBUTE_MAPPING":
      return setActionAttributeMapping(state, action);
    case "UPDATE_ATTRIBUTE_VALUES":
      return updateAttributeValues(state, action);
    default:
      return state;
  }
}

const setAttributeList = (state, action) => {
  return {
    ...state,
    attributeList: getPath(action.payload, "attribute_list", []),
  };
};

const setUserAttributeList = (state, action) => {
  return {
    ...state,
    userAttributeList: action.payload || [],
  };
};

const setActionsList = (state, action) => {
  return {
    ...state,
    actionList: action.payload || [],
  };
};

const setUserId = (state, action) => {
  return {
    ...state,
    userId: action.payload || 0,
  };
};

const setActionAttributeMapping = (state, action) => {
  return {
    ...state,
    actionAttributeMapping: action.payload || [],
  };
};

const updateAttributeValues = (state, action) => {
  const { userAttributeList = [] } = state;
  const updatedAttributeList = userAttributeList.map((item) => {
    if (
      item?.attribute_type === action?.payload?.attribute_type &&
      item?.attribute_value === action?.payload?.attribute_value
    ) {
      return {
        ...item,
        restricted_period:
          action?.payload?.restricted_period ?? item.restricted_period,
        enabled: action?.payload?.enabled ?? item.enabled,
      };
    }

    return { ...item };
  });
  return {
    ...state,
    userAttributeList: updatedAttributeList,
  };
};
